import React, { useState } from "react";
import Button from "./Button";
import { useStateContext } from "../contexts/ContextProvider";
import AddChoreModal from "./AddChoreModal";
import EditChoreModal from "./EditChoreModal";
import ChoresCard from "./ChoresCard";

const ManageChoresModal = (props) => {
  const { currentProperty } = props;
  const { chores, modal, handleModal } = useStateContext();
  const [currentChoreId, setCurrentChoreId] = useState(null);

  const currentPropertyChores = chores.filter(
    (x) => x.propertyId === currentProperty.id
  );

  const currentChore = currentPropertyChores.find(
    (x) => x.id === currentChoreId
  );

  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      {modal.addChore && <AddChoreModal currentProperty={currentProperty} />}
      {modal.editChore && (
        <EditChoreModal choreId={currentChoreId} currentChore={currentChore} />
      )}
      <div className="flex justify-center  text-xl mt-5">Manage Chores</div>
      <div
        className="flex justify-center text-blue-500 hover:text-blue-700 cursor-pointer mt-5"
        onClick={() => handleModal("addChore")}
      >
        + Add Chore
      </div>
      <ChoresCard
        chores={currentPropertyChores}
        setCurrentChoreId={setCurrentChoreId}
      />
      <div className="flex justify-center w-full mt-10">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Close"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("manageChores")}
        />
      </div>
    </div>
  );
};

export default ManageChoresModal;
